import type { FC } from 'react';
import cx from 'classnames';

import { IconUpload } from 'src/assets/icons/Upload';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
// @ts-expect-error - TextLink does not have types
import TextLink from 'src/components/TextLink';

import styles from './styles.module.scss';

interface Props {
  className?: string;
  url: string;
  displayIcon?: boolean;
}

export const CsvTemplateHint: FC<Props> = ({ className, url, displayIcon }) => {
  return (
    <div className={cx(styles.root, className)}>
      {displayIcon && <IconUpload className={styles.icon} />}

      <CustomTypography variant={TYPOGRAPHY_VARIANT.regular14}>
        Ensure your data import correctly by using{' '}
        <TextLink
          href={url}
          download="anyword_csv_template"
          data-testid="downloadCsvTemplateLink"
        >
          our CSV template
        </TextLink>
      </CustomTypography>
    </div>
  );
};
